<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4" [class.pt-4]="!embedded">
        <dx-scheduler
            id="scheduler"
            [style]="(`height: calc(100vh - ${offset}px)`)"
            [dataSource]="events$ | async"
            [(currentDate)]="currentDate"
            [currentView]="'month'"
            (onOptionChanged)="onOptionChanged($event)"
            [startDayHour]="6"
            [endDayHour]="23"
            [showAllDayPanel]="false"
            [maxAppointmentsPerCell]="4"
            appointmentTemplate="appointment-template"
            [editing]="false"
            [useDropDownViewSwitcher]="false"
            (onAppointmentDblClick)="$event.cancel = true"
            (onAppointmentClick)="onAppointmentClick($event)"
            [focusStateEnabled]="false"
            [adaptivityEnabled]="true"
            width="100%"
            (onAppointmentFormOpening)="$event.cancel = true"
        >
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="scheduler-header">Schedule</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    name="dateNavigator"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
            </dxo-toolbar>

            <dxi-scheduler-view type="month"></dxi-scheduler-view>

            <dxi-resource
                fieldExpr="displayStatus"
                label="Status"
                [dataSource]="statusResources[0].dataSource"
                [useColorAsDefault]="true"
            ></dxi-resource>

            <div *dxTemplate="let model of 'appointment-template'">
                <div class="h-100 d-flex justify-content-between overflow-hidden"
                     [ngClass]="getEventClass(getEventData(model.appointmentData))">
                    <div class="fw-medium text-truncate">
                        {{ getEventData(model.appointmentData).label | capitalCase }}
                    </div>
                    <div>{{ getEventData(model.appointmentData).count }}</div>
                </div>
            </div>
        </dx-scheduler>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <div class="d-flex flex-column gap-2">
            <div class="fw-bold mb-2">Status</div>
            @for (status of allStatuses; track status) {
                <dx-check-box
                    [text]="status | capitalCase"
                    [value]="isStatusSelected(status)"
                    (onValueChanged)="onStatusChanged(status, $event)"
                ></dx-check-box>
            }
        </div>
    </filter-panel>
    <quick-view-panel
        [(isOpened)]="isQuickViewPanelOpened"
        (pinnedChange)="onPinnedChange()"
    >
        @if (selectedAppointment; as appointment) {
            @if (employeeId && appointment.type === SchedulerEventType.Scheduled) {
                <div class="p-3">
                    <div class="mb-3 border-bottom pb-2">
                        <div class="text-uppercase small mb-1">Shift Details</div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-semibold fs-5">{{ appointment.startDate | date: 'MMMM d, y' }}</div>
                                @if (appointment.shiftCode) {
                                    <div class="small">
                                        Shift: {{ appointment.shiftCode }}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="d-flex align-items-center mb-3">
                        @for (employee of appointment.employees; track $index) {
                            <user-avatar-email
                                [employeeId]="employee.employeeId"
                                [email]="employee.employeeEmail"
                                [name]="employee.employeeName"
                                [avatarUrl]="employee.employeeAvatar"
                            ></user-avatar-email>
                        }
                    </div>

                    <div class="row g-3 mb-3">
                        <div class="col-12 col-md-6">
                            <div class="text-uppercase small">Shift Type</div>
                            <div class="fw-medium">{{ getEventData(appointment).label | capitalCase }}</div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="text-uppercase small">Shift Rate</div>
                            <div class="fw-medium">
                                @if (!appointment.shiftRate || appointment.shiftRate === 0) {
                                    <span>Base</span>
                                }
                                @if (appointment.shiftRate > 0) {
                                    <span>+${{ appointment.shiftRate }}/hour</span>
                                }
                            </div>
                        </div>
                    </div>

                    @if (appointment.scheduledHoursSpan) {
                        <div class="border-top pt-2 mt-2">
                            <div class="row g-3">
                                <div class="col-12 col-md-6">
                                    <div class="text-uppercase small">Scheduled Hours</div>
                                    <div class="fw-medium">{{ appointment.scheduledHoursSpan | toDate | date: "H'h' m'min'" }}</div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            } @else {
                <div class="p-3">
                    <div class="mb-3 border-bottom pb-2">
                        <div class="text-uppercase small mb-1">Details</div>
                        <div class="fw-semibold fs-5">{{ appointment.startDate | date: 'MMMM d, y' }}</div>
                    </div>

                    <div class="mb-3 border-bottom pb-2">
                        <div class="text-uppercase small mb-1">Status</div>
                        <div class="fw-medium fs-5" [ngClass]="getEventClass(appointment)">
                            {{ appointment.label | capitalCase }}
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="text-uppercase small mb-2">Employees ({{ appointment.employees.length }})</div>
                        <div class="d-flex flex-column gap-2">
                            @for (employee of appointment.employees; track $index) {
                                <div class="d-flex align-items-center justify-content-between">
                                    <user-avatar-email
                                        [employeeId]="employee.employeeId"
                                        [email]="employee.employeeEmail"
                                        [name]="employee.employeeName"
                                        [avatarUrl]="employee.employeeAvatar"
                                    ></user-avatar-email>
                                    @if (employee.shiftCode) {
                                        <span class="small text-muted">{{ employee.shiftCode }}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        }
    </quick-view-panel>
</div>
